export default {"src":"/_next/static/media/Airplay.4844d647.svg","height":16,"width":16};